import React from 'react';
import Modal from '../Modal/Modal'; // Теперь этот импорт работает!
import Button from '../Button/Button';
import { FormattedMessage } from 'react-intl';
import styles from './ConfirmModal.module.css';

const ConfirmModal = ({ isOpen, onClose, onConfirm, title, message, children }) => {
    return (
        // Используем базовый Modal, передавая ему title
        <Modal isOpen={isOpen} onClose={onClose} title={title}>
            <div className={styles.modalContent}>
                {/* Заголовок теперь отображается в шапке Modal, убираем его отсюда */}
                {/* <h3 className={styles.title}>{title}</h3> */}

                {message && <p className={styles.message}>{message}</p>}

                {/* Если нужно передать более сложный контент */}
                {children}

                <div className={styles.actions}>
                    <Button onClick={onClose} variant="secondary">
                        <FormattedMessage id="formSettingsPage.delete.confirm.cancel" />
                    </Button>
                    <Button onClick={onConfirm} variant="danger">
                        <FormattedMessage id="formSettingsPage.delete.confirm.submit" />
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default ConfirmModal;
